import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { SHOP_PROMPT_SCHEDULE_BY_ID_API } from '../../constants/central-api';

export default async function delete_prompt_schedule_api_call(
  scheduleId: string
): Promise<{ success: boolean; message?: string }> {
  const shopSlug = store.getState().user?.company?.shop_slug;
  const accessToken = store.getState().auth.authorization.accessToken;

  if (!shopSlug) {
    return { success: false, message: 'No shop selected.' };
  }

  const requestInfo: RequestInfo = {
    url: SHOP_PROMPT_SCHEDULE_BY_ID_API(shopSlug, scheduleId),
    method: 'DELETE',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: accessToken.type + ' ' + accessToken?.sellerToken,
    },
  };

  const res: any = await asyncHandler(
    requestInfo,
    'DELETE_PROMPT_SCHEDULE',
    'Prompt schedule deleted.',
    true
  );

  const response = res?.data;
  return response ?? { success: false };
}
